import { ModuleRouterState } from '../../types/module-router.types';

export class ModuleRouterUtils {
  publicModulePath(module: ModuleRouterState['module']): string {
    if (!module) {
      throw new Error('Can not create public module url without "module" argument!');
    }

    return `/${module}`;
  }

  publicSubmodulePath(module: ModuleRouterState['module'], submodule: ModuleRouterState['submodule']): string {
    const modulePath = this.publicModulePath(module);

    if (!submodule) {
      throw new Error('Can not create public submodule url without "submodule" argument!');
    }

    return `${modulePath}/${submodule}`;
  }

  publicDetailPath(
    module: ModuleRouterState['module'],
    submodule: ModuleRouterState['submodule'],
    detailId: ModuleRouterState['detailId']
  ): string {
    const submodulePath = this.publicSubmodulePath(module, submodule);

    if (!detailId) {
      throw new Error('Can not create public detail url without "detailId" argument!');
    }

    return `${submodulePath}/${detailId}`;
  }
}
